export function formatDateShort(isoOrDate) {
  if (!isoOrDate) return '';
  const d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatOfferValidity({ startDate, endDate }) {
  const start = formatDateShort(startDate);
  const end = formatDateShort(endDate);
  if (start && end) return `${start} – ${end}`;
  if (start && !end) return `From ${start}`;
  if (!start && end) return `Until ${end}`;
  return '';
}

export function isWithinDateWindow(now, { startDate, endDate }) {
  const t = now instanceof Date ? now.getTime() : new Date(now).getTime();
  const startT = startDate ? new Date(startDate).getTime() : null;
  const endT = endDate ? new Date(endDate).getTime() : null;
  if (startT && !Number.isNaN(startT) && t < startT) return false;
  if (endT && !Number.isNaN(endT) && t > endT) return false;
  return true;
}

